<template>
  <router-link class="navItem" :to="`/${data.slug}`" :class="{'active': active}" @click.native="$store.dispatch('toggleShow')">
    <div class="item__content">
      <div class="item__index">0{{index}}</div>
      <div class="item__title">
        <h2>{{data.title}}</h2>
        <p>{{data.subtitle}}</p>
      </div>
      <img :src="image" alt="">
    </div>
  </router-link>
</template>

<script>

export default {
  name: 'navItem',
  props:['data', 'index', 'active'],
  data() {
    return{
      image: null,
    }
  },
  mounted() {
    this.image = require(`@/assets/images/projects/bg/${this.data.slug}.jpg`)
  }
}
</script>

<style lang="scss">
.navItem {
  display: flex;
  flex-direction: row;
  height: calc(100vh / 5);  
  width: 100%;
  position: relative;
  transition: all .3s var(--easing);
  text-decoration: none;
  pointer-events: auto;
  overflow: hidden;
  &:hover, &.active {
    .item__content{
       &::after, &::before{
        transition: transform .45s var(--easing);        
        transform: scaleX(0)
      }
      .item__title{
        h2{
          color: var(--white);
        }
        p{
          width: 100%;
        }
      }
      img{
        transform: scale(1.1)
      }
    }
  }
  &.active{
    .item__content{
      .item__index::after{
        transform: scaleX(1)
      }
    }
  }
  .item__content{
    z-index: 10;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    overflow: hidden;
    &::before{
      content: "";
      position: absolute;
      z-index: 1;
      background: var(--black);
      left: 0;
      width: 50vw;
      height: 100%;
      transform-origin: 0% 50%;
      transform: scaleX(1);
      transition: transform .2s var(--easing);
    }
    &::after{
      content: "";
      position: absolute;
      z-index: 1;
      background: var(--black);
      right: 0;
      width: 50vw;
      height: 100%;
      transform-origin: 100% 50%;      
      transform: scaleX(1);
      transition: transform .2s var(--easing);
    }
    .item__index{
      margin-right: 20px;
      margin-left: calc(25vw + 4px);
      font-family: var(--DIN);
      font-size: 2.4rem;
      font-weight: 600;
      color: var(--white);
      margin-bottom: 60px;
      position: relative;
      z-index: 2;
      &:after{
        content: "";
        position: absolute;
        bottom: -4px;
        left: 0;
        width: 100%;
        height: 2px;
        background: var(--primary);
        transform-origin: 0% 50%;
        transform: scaleX(0);
        transition: transform .25s var(--easing);
      }
    }
    .item__title{
      position: relative;
      z-index: 2;
      h2{
        font-family: var(--editor);
        font-size: 6.4rem;
        font-weight: 600;
        color: transparent;
        -webkit-text-stroke: 1px var(--white);
        line-height: 50px;
      }
      p{
        font-family: var(--conduitITC);
        font-size: 1.4rem;
        font-weight: 400;
        margin-top: 20px;
        color: var(--primary);
        white-space: nowrap;
        overflow: hidden;
        width: 0%;
        transition: width .4s var(--easing);
      }
    }
    img{
      position: absolute;
      width: 100%;
      height: auto;
      opacity: .2;
      transform: scale(1);      
      transition: transform .55s var(--easing);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/NavItem.vue